var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSearch = function SvgIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15.283 14.218-4.05-4.043A5.94 5.94 0 0 0 12.5 6.5a6 6 0 1 0-6 6 5.94 5.94 0 0 0 3.675-1.267l4.042 4.05zM2 6.5a4.5 4.5 0 1 1 7.71 3.15l-.06.06A4.5 4.5 0 0 1 2 6.5"
  })));
};
export default SvgIconSearch;